import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, firstValueFrom, of } from 'rxjs';
import {
    KudosRequest,
    MoodRequest,
    QuestionAnswerResponse,
    PollRequest,
    UserRequestBacklog,
    FeedbackHookRequest
} from "./user-request.types";

@Injectable({
    providedIn: 'root'
 })
export class UserRequestService {

    constructor(private http: HttpClient) { }

    async nextUserRequest(teamId: string = null, currentRequest: string = null): Promise<UserRequestBacklog> {
        const next =
            this.http.post<Promise<UserRequestBacklog>>('/api/question/next', {teamId: teamId, currentRequest: currentRequest}).pipe(
                catchError(() => {
                    return of(null);
                })
            )
        return await firstValueFrom(next);
    }

    async previousUserRequest(teamId: string, currentRequest: string = null): Promise<UserRequestBacklog> {
        return await firstValueFrom(this.http.post<Promise<UserRequestBacklog>>('/api/question/previous', {teamId: teamId, currentRequest: currentRequest}));
    }

    async postTheUserAnswerToTheQuestion(questionId: string, choiceId: string){
        return await firstValueFrom(
            this.http.put<Promise<QuestionAnswerResponse>>('/api/question/' + questionId + '/choice/' + choiceId, { questionId: questionId, choiceId: choiceId})
        )
    }

    getTypedUserRequest(requestInfo : UserRequestBacklog) : MoodRequest | PollRequest | KudosRequest {
        if(requestInfo.current_request?.type){
            switch(requestInfo.current_request.type){
                case 'MoodRequest':
                    return requestInfo.current_request as MoodRequest;
                case 'PollRequest':
                    return requestInfo.current_request as PollRequest;
                case 'KudosRequest':
                    return requestInfo.current_request as KudosRequest;
                case 'FeedbackHookRequest':
                    return requestInfo.current_request as FeedbackHookRequest;
                default:
                    return {
                        type: 'KudosRequest'
                    } as KudosRequest;
            }
        }else{
            return {
                type: 'KudosRequest'
            } as KudosRequest;
        }
    }
}